import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import FolderPaneContainer from './FolderPaneContainer';
import { setShowFolderPane, shouldShowFolderPane } from 'owa-mail-layout';

const leftPaneStyles = require('./MailLeftPane.scss');

export interface MailLeftPaneAsOverlayrProps {
    isLeftRailVisible: boolean;
}
export default observer(function MailLeftPaneAsOverlay(props: MailLeftPaneAsOverlayrProps) {
    const onDismissFolderPaneOverlay = React.useCallback(
        (evt: React.SyntheticEvent<HTMLElement, Event>) => {
            /**
             * evt will be undefined if the panel is being dismissed explicitly and not due
             * to click on the overlay that shall generate the light dismiss
             * We want to avoid the conflict of pane getting toggled between the states when
             * dismissed through hamburger button. E.g. When panel is open and user clicks on the
             * hamburger button we let the button click handler toggle panel state rather
             * than light dismiss. If we let both of them handle then panel may close and re-open.
             */
            if (!evt) {
                return;
            }

            setShowFolderPane(false);
        },
        []
    );
    return (
        <Panel
            className={leftPaneStyles.overlayLeftPane}
            isLightDismiss={true}
            isOpen={shouldShowFolderPane()}
            hasCloseButton={false}
            focusTrapZoneProps={{
                forceFocusInsideTrap: false,
                isClickableOutsideFocusTrap: true,
            }}
            onDismiss={onDismissFolderPaneOverlay}
            type={PanelType.smallFixedNear}>
            <FolderPaneContainer leftNavWidth={280} isLeftRailVisible={props.isLeftRailVisible} />
        </Panel>
    );
});
